import { PropsWithChildren, ReactElement } from 'react'

// styles
import styles from './button.module.scss'

type ButtonBaseProps = {
	readonly appendIcon?: ReactElement
	readonly label?: string
	readonly prependIcon?: ReactElement
	readonly theme?: 'primary' | 'secondary'
}

type ButtonElementProps = {
	readonly type: 'button' | 'reset' | 'submit'
} & ButtonBaseProps &
	React.ButtonHTMLAttributes<HTMLButtonElement>

type AnchorElementProps = {
	readonly type: 'link'
} & ButtonBaseProps &
	React.AnchorHTMLAttributes<HTMLAnchorElement>

export type ButtonProps = ButtonElementProps | AnchorElementProps

const Button = (props: ButtonProps): JSX.Element => {
	const {
		appendIcon,
		children,
		className,
		label,
		prependIcon,
		theme,
		type,
		...attr
	} = props
	const cssClassName = [styles.button, className].join(' ').trim()

	const ButtonElement = ({ children }: PropsWithChildren) => {
		return (
			<>
				{type !== 'link' ? (
					<button
						className={cssClassName}
						data-theme={theme}
						{...(attr as ButtonElementProps)}
						type={type}
					>
						{children}
					</button>
				) : (
					<a
						className={cssClassName}
						data-theme={theme}
						{...(attr as AnchorElementProps)}
					>
						{children}
					</a>
				)}
			</>
		)
	}

	return (
		<ButtonElement>
			{prependIcon && (
				<span
					className={[styles.icon, styles.prependIcon]
						.join(' ')
						.trim()}
				>
					{prependIcon}
				</span>
			)}

			{label && <span className={styles.label}>{label}</span>}

			{appendIcon && (
				<span
					className={[styles.icon, styles.appendIcon]
						.join(' ')
						.trim()}
				>
					{appendIcon}
				</span>
			)}
		</ButtonElement>
	)
}

export default Button
